import script from "./OpenNewWindowIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./OpenNewWindowIcon.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__